import { useEffect, useState } from 'react';
import './ClinicalProfessionalReferenceMobile.scss';
import { staffingTypes, questions, supervisor, evalSelectOptions } from "./QuestionData";
import { ClinicalProfessionalAnswers, ReferralData } from '../tp-core-types/ClinicalProFessionalAnswers';

interface ClinicalProfessionalReferenceMobileProps {
    answerUpdated: (answers: ClinicalProfessionalAnswers) => void;
    defaultValues: ReferralData; // Add this line
}
//
export default function ClinicalProfessionalReferenceMobile({ answerUpdated, defaultValues }: ClinicalProfessionalReferenceMobileProps) {
    const [answerObject, setAnswerObject] = useState<ClinicalProfessionalAnswers>({
        // ReferenceGuid: "",
        HistoryTypeId: defaultValues.historyTypeId,
        HcpName: defaultValues.name,
        HcpDiscipline: defaultValues.discipline,
        HcpSpecialty: defaultValues.specialty,
        WasCharge: defaultValues.wasCharge,
        EmrWorked: "",
        SafeCareLevel: 0,
        DependableLevel: 0,
        ProfessionalLevel: 0,
        CooperativeLevel: 0,
        CommunicatorLevel: 0,
        AttendanceLevel: 0,
        AssetLevel: 0,
        Comments: "",
        SupervisorName: defaultValues.supervisorName,
        SupervisorTitle: defaultValues.supervisorTitle,
        FacilityName: defaultValues.facilityName,
        ReferenceDate: defaultValues.referenceDate,
        CityState: defaultValues.facCityState,
        StartDate: defaultValues.evalStartDate,
        EndDate: defaultValues.evalEndDate,
        Unit: defaultValues.unit,
    } as ClinicalProfessionalAnswers);
    const [staffingOptions] = useState<{ label: string; value: string }[]>(staffingTypes);
    const [evalOptions] = useState<{ label: string; value: number }[]>(evalSelectOptions);
    
    useEffect(() => {
        answerUpdated(answerObject);
    }, [answerObject]);
    
    function UpdateDataTextArea(event: React.ChangeEvent<HTMLTextAreaElement>) {
        const { name, value } = event.target;
        setAnswerObject((prevState) => ({
            ...prevState || {} as ClinicalProfessionalAnswers,
            [name]: value,
        }));
        // answerUpdated(answerObject);
    }

    function UpdateSelectValue(event: React.ChangeEvent<HTMLSelectElement>) {
        const { name, value } = event.target;
        setAnswerObject((prevState) => ({
            ...prevState || {} as ClinicalProfessionalAnswers,
            [name]: value,
        }));
        // answerUpdated(answerObject);
    }

    function updateInputField(event: React.ChangeEvent<HTMLInputElement>): void {
        const { name, value } = event.target;
        if (name === "WasCharge") {
            setAnswerObject((prevState) => ({
                ...prevState || {} as ClinicalProfessionalAnswers,
                [name]: value === "1" ? true : false,
            }));
            
        } else {
            setAnswerObject((prevState) => ({
                ...prevState || {} as ClinicalProfessionalAnswers,
                [name]: value,
            }));
            // setFormValues((prevState) => ({
            //     ...prevState || {} as ClinicalProfessionalAnswers,
            //     [name]: value,
            // }));
        }
        // answerUpdated(answerObject);
    }
   
   function getStaffingTypes() {
        const allOptions = staffingOptions;
        return allOptions.filter(
            option => option.value !== "0" || answerObject.HistoryTypeId === "0" // Exclude the option with value 0
        );
    }

    function getEvalSelectOptions(name: string) {
        const allOptions = evalOptions;
        return allOptions.filter(
            option => option.value !== 0 || answerObject[name as keyof ClinicalProfessionalAnswers] === 0 // Exclude the option with value 0
        );
    }

    return (
        <div className="container">
            <h2 className="title">
                CLINICAL & PROFESSIONAL REFERENCE
            </h2>
            <p className="subtitle">
                As required by The Joint Commission (TLC), this form is requested to provide information on the competency and performance of the healthcare clinician for a contingency staff position.
            </p>

            <div className="clinic-section">
                <div className="section-title">CLINICIAN INFORMATION</div>
                <label>
                    <select name="HistoryTypeId" onChange={UpdateSelectValue} value={answerObject.HistoryTypeId?.toString()} className="clinician-select">
                        {getStaffingTypes().map((option) => (
                            <option key={option.value} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </select>
                </label>
            </div>
            <div className='hcp-info'>
                <div className="grid grid-3">
                    <div className="grid-row">
                        <label className="label" htmlFor='hcpName'>Name</label>
                        <div className="input-div">
                            <input 
                            onChange={(e) => { updateInputField(e); }} 
                            value={answerObject.HcpName} name="HcpName" type="text" className="input" id="hcpName" />
                        </div>
                    </div>
                    <div className="grid-row">
                        <label className="label" htmlFor='hcpUnit'>Unit</label>
                        <div className="input-div">
                            <input 
                            onChange={(e) => { updateInputField(e); }} 
                            value={answerObject.Unit} name="Unit" type="text" className="input" id="hcpUnit" />
                        </div>
                    </div>
                    <div className="grid-row">
                        <label className="label" htmlFor='hcpDiscipline'>Discipline</label>
                        <div className="input-div">
                            <input type="text" 
                            onChange={updateInputField} 
                            value={answerObject.HcpDiscipline} name='HcpDiscipline' className="input" id="hcpDiscipline" />
                        </div>
                    </div>
                    <div className="grid-row">
                        <label className="label" htmlFor='hcpSpecialty'>Specialty</label>
                        <div className="input-div">
                            <input type="text" onChange={updateInputField} value={answerObject.HcpSpecialty} name="HcpSpecialty" className="input" id="hcpSpecialty" />
                        </div>
                    </div>
                </div>
            </div>

            <div className="blue-box">
                The person has registered with TRS Healthcare and has listed you as a previous employer. We would appreciate your assistance in verifying that the employment information is correct and evaluating their job performance.
            </div>

            <div className="grid grid-2">
                <table border={1} cellPadding={0} cellSpacing={0}>
                    <tbody>
                        <tr>
                            <td>Was traveler ever in a Charge capacity?</td>
                            <td>
                                <label><input checked={answerObject.WasCharge === true ? true : false} onChange={updateInputField} type="radio" name="WasCharge" value={1} /> Yes</label>
                            </td>
                            <td>
                                <label><input checked={answerObject.WasCharge === false ? true : false} onChange={updateInputField} type="radio" name="WasCharge" value={0} /> No</label>
                            </td>
                        </tr>
                        <tr>
                            <td colSpan={3}>
                                <label htmlFor="emr">EMR:</label>
                                <input onChange={updateInputField} name="EmrWorked" type="text" id="emr" />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div className="yellow-header">
                Clinical and Professional Evaluation
            </div>

            {questions.map((question, index) => (
                <div className="mb-4" key={index}>
                    <label className="question-label">{question.question}
                        <div className='question-description'>{question.description}</div>
                    </label>
                    <div className="question-select">
                        <select onChange={UpdateSelectValue} name={question.name}>
                            {getEvalSelectOptions(question.name).map((option) => (
                                <option key={option.value} value={option.value}>
                                    {option.label}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
            ))}

            <div className="clinical-professional-reference-block-footer">
                <div>
                    <ul>
                        <li>Exceeds Expectations: Performance consistently above job requirements.</li>
                        <li>Meets Expectations: Performance consistently met job requirements.</li>
                        <li>Needs Improvement: Performance did not fully meet expectations; improvement needed.</li>
                        <li>Did not Observe: No direct observation of this behavior or skill.</li>
                    </ul>
                </div>
            </div>

            <div className="clinical-professional-reference-block-comments">
                <div className="comment-title">Comments:</div>
                <div>
                    <textarea
                        onChange={UpdateDataTextArea}
                        aria-label="reference-comments"
                        name="Comments"
                        className="textarea-comments"
                        rows={5}
                        placeholder="Please type your comments here."
                        id="reference-comments"
                    ></textarea>
                </div>
                
            </div>

            <div className="clinical-professional-reference-block-mobile">
                <div className="header2">SUPERVISOR SUBMITTING REFERENCE</div>
                {supervisor.map((item, index) => (
                    <div className="grid-row" key={index}>
                        <label className="label" htmlFor={item.id}>{item.question}</label>
                        <div className="text-input">
                            <input
                                onChange={updateInputField}
                                
                                value={answerObject[item.name as keyof ClinicalProfessionalAnswers] != null
                                    ? (item.name === "ReferenceDate" || item.name === "StartDate" || item.name === "EndDate"
                                        ? String(answerObject[item.name as keyof ClinicalProfessionalAnswers]) :
                                            String(answerObject[item.name as keyof ClinicalProfessionalAnswers]))
                                    : ""}
                                type="text"
                                id={item.id}
                                name={item.name}
                                className="clinical-professional-reference-input"
                            />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}